import { shallowEqual, useSelector } from 'react-redux'
import { TAccount } from 'domain/types'
import { AppState } from 'state'

export const useAccounts = (): TAccount[] => {
  const data = useSelector((state: AppState) => {
    return state.account.accounts || []
  }, shallowEqual)
  return data
}

export default useAccounts
